import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import * as React from 'react'

import Box from '../base/Box'
import { Card, CardActionArea, CardContent } from '../base/Card'
import Typography from '../base/Typography'

export type PayrollCardProps = {
  id: number
  month: string
  year: string
  amount: number
  onClick(): void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 200,
      borderRadius: theme.spacing(1),
      boxShadow: 'none',
      overflow: 'visible',
      border: `none`,
      background: fade(theme.palette.primary.main, 0.03)
    },
    content: {
      paddingBottom: 0
    },
    action: {
      padding: theme.spacing(0.5),
      paddingTop: 0,
      justifyContent: 'flex-end'
    },
    typography: {
      marginTop: theme.spacing(0.5),
      color: theme.palette.grey[700]
    },
    icon: {
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      color: theme.palette.grey[700]
    },
    spacingRight: {
      marginRight: theme.spacing(0.5)
    }
  })
)

const PayrollCard: React.FC<PayrollCardProps> = (props) => {
  const { id, year, month, amount, onClick } = props
  const classes = useStyles()
  return (
    <CardActionArea onClick={onClick}>
      <Card aria-label={`card-payroll-${id}`} classes={{ root: classes.root }}>
        <CardContent classes={{ root: classes.content }}>
          <Box display="flex">
            <Typography className={classes.spacingRight} variant="subtitle2">
              {month}
            </Typography>
            <Typography variant="subtitle2">{year}</Typography>
          </Box>
          <Typography classes={{ root: classes.typography }} variant="h3">
            ${amount}
          </Typography>
        </CardContent>
      </Card>
    </CardActionArea>
  )
}

export default PayrollCard
